module.exports = __webpack_public_path__ + "static/media/uwindsor_logo.1e873721.jpeg";